<template>
  <svg
    id="Layer_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="170.828px"
    height="21.281px"
    viewBox="0 0 170.828 21.281"
    enable-background="new 0 0 170.828 21.281"
    xml:space="preserve"
  >
    <g>
      <path
        :fill="fillColor"
        d="M33.561,8.162c-0.765-0.641-1.697-1.136-2.777-1.504c-1.084-0.356-2.271-0.542-3.557-0.542
-1.514,0-2.85,0.193-4.006,0.573c-1.158,0.383-2.134,0.908-2.92,1.586c-0.791,0.675-1.393,1.473-1.799,2.382
-0.418,0.915-0.617,1.916-0.617,3c0,1.183,0.234,2.227,0.709,3.146c0.479,0.913,1.121,1.684,1.938,2.312
0.824,0.628,1.78,1.106,2.863,1.428c1.076,0.324,2.246,0.485,3.49,0.485c1.262,0,2.447-0.173,3.551-0.516
1.106-0.343,2.076-0.833,2.908-1.482c0.83-0.651,1.479-1.446,1.954-2.385c0.476-0.946,0.712-2.028,0.712-3.248
0-1.062-0.22-2.044-0.647-2.938C34.931,9.563,34.331,8.8,33.561,8.162z M28.755,16.119c-0.442,0.578-1.051,0.868-1.815,0.868
-0.855,0-1.494-0.335-1.895-1.011c-0.408-0.672-0.615-1.467-0.615-2.391c0-0.425,0.049-0.85,0.141-1.271
0.086-0.417,0.23-0.785,0.439-1.101c0.201-0.319,0.456-0.573,0.777-0.768c0.32-0.196,0.711-0.289,1.188-0.289
0.834,0,1.447,0.34,1.845,1.027c0.396,0.682,0.591,1.485,0.591,2.401C29.41,14.688,29.19,15.531,28.755,16.119z"
      />
      <path
        :fill="fillColor"
        d="M83.383,19.997l-0.666-3.769c-0.02-0.099-0.079-0.168-0.174-0.217c-0.092-0.047-0.196-0.048-0.299-0.014
c-0.4,0.113-0.811,0.199-1.229,0.257c-0.424,0.06-0.889,0.087-1.388,0.087c-0.466,0-0.909-0.058-1.331-0.176
c-0.416-0.113-0.797-0.285-1.135-0.508c-0.332-0.23-0.606-0.523-0.805-0.893c-0.199-0.355-0.303-0.783-0.303-1.281
c0-0.856,0.311-1.541,0.932-2.056c0.621-0.513,1.426-0.77,2.416-0.77c0.612,0,1.115,0.042,1.517,0.114
c0.405,0.074,0.739,0.166,1.012,0.258c0.248,0.096,0.416,0.008,0.507-0.258l0.885-3.796c0-0.174-0.088-0.286-0.26-0.34
c-0.69-0.212-1.391-0.354-2.093-0.417c-0.71-0.069-1.342-0.104-1.912-0.104c-1.664,0-3.104,0.216-4.308,0.634
c-1.215,0.418-2.209,0.978-3.002,1.683c-0.789,0.702-1.377,1.505-1.769,2.412c-0.39,0.902-0.584,1.842-0.584,2.81
c0,1.129,0.212,2.142,0.632,3.043c0.421,0.904,1.021,1.681,1.803,2.33c0.774,0.646,1.721,1.143,2.821,1.479
c1.11,0.348,2.353,0.518,3.74,0.518c0.946,0,1.843-0.055,2.682-0.156c0.849-0.105,1.549-0.28,2.12-0.533
C83.362,20.261,83.421,20.148,83.383,19.997z"
      />
      <path
        :fill="fillColor"
        d="M62.902,4.806c0.702,0.263,1.434,0.296,2.177,0.154c0.802-0.154,1.505-0.487,2.069-1.036
c0.539-0.529,0.845-1.142,0.791-1.88c0-0.025,0.016-0.055,0.033-0.079c0.199-0.277,0.1-0.563-0.237-0.683
c-0.028-0.007-0.062-0.028-0.073-0.05c-0.312-0.49-0.775-0.815-1.35-1.021c-0.819-0.279-1.645-0.264-2.398-0.062
c-0.771,0.218-1.381,0.546-1.863,1.051C61.562,1.723,61.29,2.308,61.341,3c0,0.027-0.015,0.061-0.027,0.082
c-0.204,0.27-0.107,0.558,0.234,0.682c0.025,0.01,0.06,0.034,0.077,0.057C61.926,4.283,62.356,4.6,62.902,4.806z"
      />
      <path
        :fill="fillColor"
        d="M67.718,6.115h-5.683c-0.253,0-0.454,0.19-0.454,0.416v0.171v0.101v0.172v13.194v0.166v0.107v0.166
c0,0.227,0.201,0.414,0.454,0.414h5.683c0.25,0,0.454-0.188,0.454-0.414v-0.166v-0.107v-0.166V6.975V6.803V6.702V6.531
C68.172,6.305,67.968,6.115,67.718,6.115z"
      />
      <path
        :fill="fillColor"
        d="M57.534,16.21c-0.465,0-0.843-0.377-0.843-0.842v-1.391v-1.502v-1.168l0.003-0.004v-0.402v-0.121h2.998
c0.133,0,0.24-0.093,0.24-0.213V6.425c0-0.12-0.107-0.214-0.24-0.214h-2.998V3.074c0-0.119-0.104-0.217-0.239-0.217l-5.879,2.168
c-0.139,0.042-0.243,0.102-0.243,0.219v0.966h-1.669c-0.131,0-0.236,0.094-0.236,0.214v4.143c0,0.12,0.105,0.213,0.236,0.213h1.669
v0.121v0.399v3.713c0,2.067,0.5,3.575,1.494,4.512c0.425,0.404,1.007,0.753,1.754,1.052c0.735,0.296,1.575,0.444,2.514,0.444
c0.757,0,1.457-0.045,2.093-0.131c0.635-0.082,1.133-0.193,1.49-0.326c0.173-0.082,0.255-0.184,0.255-0.318v-3.938
c0-0.04-0.013-0.073-0.022-0.106c-0.021,0.002-0.042,0.008-0.062,0.008H57.534z"
      />
      <path
        :fill="fillColor"
        d="M10.424,6.115c-0.609,0-1.166,0.061-1.654,0.175C8.281,6.407,7.85,6.553,7.471,6.726
C7.137,6.875,6.847,7.044,6.594,7.228V6.82c0-0.228-0.203-0.413-0.457-0.413H0.459C0.204,6.407,0,6.592,0,6.82v3.35
c0.432,0.036,0.771,0.394,0.771,0.833v5.149c0,0.439-0.339,0.797-0.771,0.832v3.475v0.156c0,0.232,0.204,0.414,0.459,0.414h5.678
c0.254,0,0.457-0.182,0.457-0.414v-0.156v-8.284c0-0.003,0-0.005,0.002-0.011H6.594v-0.148c0-0.002,0-0.006,0.002-0.007
c0.021-0.865,0.797-1.562,1.754-1.562c0.928,0,1.682,0.657,1.742,1.482c0.006,0.013,0.008,0.021,0.011,0.033v0.128h-0.011
c0.006,0.007,0.008,0.019,0.011,0.031v3.777v0.154v3.729v0.16v0.518v0.156c0,0.232,0.204,0.414,0.456,0.414h5.643
c0.252,0,0.459-0.182,0.459-0.414v-0.156v-2.592v-0.159v-1.655v-0.154v-3.172v-0.007v-0.153v-0.005c0-2.13-0.557-3.733-1.671-4.817
C13.875,6.658,12.354,6.115,10.424,6.115z"
      />
      <path
        :fill="fillColor"
        d="M47.184,6.464c-0.068-0.206-0.329-0.281-0.551-0.281c-1.115,0-1.973,0.47-1.973,0.47
c-0.416,0.165-0.796,0.4-1.143,0.705V6.745V6.542c0-0.231-0.207-0.418-0.465-0.418H38.58h-0.814h-0.373
c-0.258,0-0.464,0.188-0.464,0.418v0.202v13.66v0.204c0,0.227,0.206,0.42,0.464,0.42h0.373h0.814h4.473
c0.105,0,0.197-0.033,0.275-0.08c0.107-0.045,0.164-0.125,0.182-0.253c0-0.004,0-0.011,0.002-0.018
c0-0.013,0.006-0.024,0.006-0.042v-9.017c0-0.463,0.377-0.838,0.841-0.838h1.851l0.003-0.002h0.753
c0.133,0,0.236-0.094,0.236-0.213v-0.439V8.201c0-0.362,0-0.725,0-1.087V6.583c0-0.004,0-0.009,0-0.009v-0.15L47.184,6.464z"
      />
    </g>
    <g>
      <path
        :fill="fillColor"
        d="M93.432,18.281c-0.37-0.227-0.555-0.685-0.555-1.373v-4.68c0-0.623,0.168-1.074,0.506-1.352
      c0.336-0.278,0.742-0.417,1.219-0.417c0.688,0,1.281,0.011,1.78,0.033c0.498,0.022,1.069,0.052,1.714,0.088v1.132H95.03
      c-0.257,0-0.454,0.064-0.593,0.192c-0.14,0.128-0.209,0.321-0.209,0.577v1.439l3.373,0.076v1.066l-3.373,0.077v1.396
      c0,0.542,0.264,0.812,0.791,0.812h3.076v1.132c-0.923,0.081-2.037,0.128-3.34,0.144C94.242,18.623,93.801,18.508,93.432,18.281z"
      />
      <path
        :fill="fillColor"
        d="M98.92,12.677h1.395l1.473,4.626l1.506-4.626h1.384l-2.143,5.89h-1.56L98.92,12.677z"
      />
      <path
        :fill="fillColor"
        d="M106.297,18.353c-0.369-0.18-0.637-0.484-0.802-0.912c-0.165-0.429-0.247-1.035-0.247-1.818
c0-0.799,0.078-1.414,0.236-1.846c0.157-0.433,0.417-0.736,0.779-0.912c0.363-0.176,0.874-0.264,1.533-0.264
c0.578,0,1.036,0.059,1.373,0.176s0.582,0.32,0.736,0.609s0.23,0.694,0.23,1.215c0,0.541-0.155,0.93-0.467,1.164
c-0.311,0.234-0.764,0.352-1.357,0.352h-1.725c0.016,0.381,0.066,0.676,0.154,0.885s0.243,0.361,0.467,0.455
c0.223,0.096,0.547,0.144,0.973,0.144h1.779v0.802c-0.395,0.074-0.748,0.129-1.061,0.165c-0.311,0.036-0.668,0.056-1.07,0.056
C107.178,18.623,106.667,18.533,106.297,18.353z M108.182,15.292c0.264,0,0.453-0.051,0.571-0.153
c0.116-0.103,0.176-0.282,0.176-0.538c0-0.381-0.085-0.645-0.253-0.791s-0.461-0.221-0.879-0.221c-0.314,0-0.559,0.05-0.73,0.148
c-0.172,0.1-0.297,0.27-0.373,0.512c-0.078,0.241-0.116,0.59-0.116,1.043H108.182z"
      />
      <path
        :fill="fillColor"
        d="M111.455,12.677h1.109l0.254,0.615c0.271-0.204,0.58-0.375,0.928-0.51c0.348-0.136,0.693-0.203,1.039-0.203
c0.644,0,1.109,0.188,1.395,0.565c0.285,0.377,0.429,0.877,0.429,1.499v3.923h-1.362V14.81c0-0.315-0.088-0.561-0.264-0.736
s-0.414-0.264-0.715-0.264c-0.271,0-0.52,0.04-0.746,0.12c-0.228,0.081-0.462,0.202-0.703,0.362v4.274h-1.363V12.677z"
      />
      <path
        :fill="fillColor"
        d="M118.822,18.105c-0.282-0.307-0.416-0.827-0.401-1.56l0.044-2.769h-0.923v-0.879l0.967-0.221l0.198-1.647
h1.065v1.647h1.494v1.1h-1.494v2.758c0,0.344,0.063,0.584,0.192,0.719c0.128,0.137,0.295,0.215,0.5,0.236l0.736,0.077v1h-0.979
C119.57,18.567,119.104,18.414,118.822,18.105z"
      />
      <path
        :fill="fillColor"
        d="M125.365,12.677h1.109l0.253,0.615c0.315-0.227,0.634-0.402,0.956-0.527
c0.322-0.124,0.688-0.186,1.099-0.186c0.352,0,0.653,0.076,0.906,0.23c0.253,0.153,0.448,0.358,0.588,0.615
c0.308-0.227,0.657-0.425,1.05-0.594c0.391-0.168,0.767-0.252,1.125-0.252c1.238,0,1.857,0.707,1.857,2.119v3.868h-1.362V14.81
c0-0.315-0.088-0.561-0.264-0.736s-0.414-0.264-0.714-0.264c-0.25,0-0.508,0.047-0.775,0.143s-0.518,0.223-0.752,0.385
c0.051,0.146,0.076,0.314,0.076,0.505v3.725h-1.361V14.81c0-0.315-0.088-0.561-0.264-0.736s-0.414-0.264-0.715-0.264
c-0.271,0-0.52,0.04-0.747,0.12c-0.228,0.081-0.462,0.202-0.703,0.362v4.274h-1.362V12.677z"
      />
      <path
        :fill="fillColor"
        d="M135.906,18.232c-0.274-0.268-0.412-0.628-0.412-1.082v-0.494c0-0.469,0.16-0.843,0.479-1.121
s0.793-0.418,1.423-0.418h1.681v-0.516c0-0.221-0.037-0.396-0.109-0.527c-0.074-0.133-0.209-0.232-0.406-0.303
c-0.198-0.069-0.484-0.104-0.857-0.104h-1.779v-0.791c0.666-0.183,1.436-0.274,2.307-0.274c0.747,0,1.302,0.146,1.664,0.439
c0.363,0.293,0.545,0.783,0.545,1.473v4.054h-1.066l-0.23-0.638c-0.074,0.066-0.224,0.156-0.451,0.27
c-0.227,0.113-0.492,0.215-0.796,0.303s-0.606,0.131-0.907,0.131C136.542,18.632,136.182,18.5,135.906,18.232z M138.467,17.517
c0.34-0.105,0.544-0.177,0.609-0.214v-1.538l-1.274,0.066c-0.638,0.051-0.956,0.333-0.956,0.846v0.242
c0,0.264,0.075,0.453,0.226,0.57c0.149,0.117,0.343,0.18,0.577,0.188C137.854,17.677,138.126,17.625,138.467,17.517z"
      />
      <path
        :fill="fillColor"
        d="M141.9,12.677h1.109l0.253,0.615c0.271-0.204,0.58-0.375,0.929-0.51c0.348-0.136,0.693-0.203,1.038-0.203
c0.644,0,1.109,0.188,1.396,0.565c0.285,0.377,0.428,0.877,0.428,1.499v3.923h-1.361V14.81c0-0.315-0.088-0.561-0.264-0.736
s-0.414-0.264-0.715-0.264c-0.271,0-0.52,0.04-0.747,0.12c-0.228,0.081-0.462,0.202-0.703,0.362v4.274H141.9V12.677z"
      />
      <path
        :fill="fillColor"
        d="M148.662,18.232c-0.274-0.268-0.412-0.628-0.412-1.082v-0.494c0-0.469,0.16-0.843,0.479-1.121
s0.793-0.418,1.423-0.418h1.681v-0.516c0-0.221-0.037-0.396-0.109-0.527c-0.074-0.133-0.209-0.232-0.406-0.303
c-0.198-0.069-0.484-0.104-0.857-0.104h-1.779v-0.791c0.666-0.183,1.436-0.274,2.307-0.274c0.747,0,1.302,0.146,1.664,0.439
c0.363,0.293,0.545,0.783,0.545,1.473v4.054h-1.066l-0.23-0.638c-0.074,0.066-0.224,0.156-0.451,0.27
c-0.227,0.113-0.492,0.215-0.796,0.303s-0.606,0.131-0.907,0.131C149.298,18.632,148.938,18.5,148.662,18.232z M151.223,17.517
c0.34-0.105,0.544-0.177,0.609-0.214v-1.538l-1.274,0.066c-0.638,0.051-0.956,0.333-0.956,0.846v0.242
c0,0.264,0.075,0.453,0.226,0.57c0.149,0.117,0.343,0.18,0.577,0.188C150.609,17.677,150.882,17.625,151.223,17.517z"
      />
      <path
        :fill="fillColor"
        d="M160.117,13.425l-1.045,0.143c0.162,0.146,0.291,0.314,0.391,0.506c0.099,0.189,0.148,0.465,0.148,0.824
c0,0.534-0.169,0.967-0.506,1.296c-0.336,0.329-0.871,0.494-1.604,0.494h-1c-0.527,0-0.791,0.161-0.791,0.483
c0,0.139,0.053,0.24,0.159,0.303s0.236,0.093,0.39,0.093h1.748c0.695,0,1.217,0.138,1.564,0.412s0.522,0.709,0.522,1.302v0.188
c0,0.578-0.185,1.025-0.556,1.34c-0.369,0.314-0.92,0.473-1.652,0.473h-1.726c-0.579,0-1.046-0.125-1.401-0.373
c-0.354-0.25-0.532-0.602-0.532-1.055v-0.209c0-0.301,0.083-0.562,0.247-0.786c0.165-0.224,0.387-0.397,0.665-0.522
c-0.19-0.102-0.335-0.235-0.435-0.4c-0.099-0.164-0.148-0.346-0.148-0.544c0-0.286,0.086-0.525,0.259-0.72
c0.172-0.193,0.412-0.324,0.72-0.39c-0.352-0.169-0.603-0.401-0.753-0.698c-0.149-0.297-0.226-0.627-0.226-0.994
c0-0.659,0.2-1.145,0.6-1.455c0.398-0.312,0.994-0.467,1.785-0.467h3.176V13.425z M156.49,18.589c-0.285,0-0.52,0.067-0.703,0.203
c-0.183,0.135-0.273,0.331-0.273,0.588v0.176c0,0.256,0.088,0.446,0.264,0.57c0.176,0.125,0.424,0.188,0.746,0.188h1.197
c0.345,0,0.612-0.066,0.803-0.197c0.19-0.133,0.285-0.326,0.285-0.583v-0.187c0-0.506-0.336-0.758-1.01-0.758H156.49z
 M158.155,15.414c0.15-0.168,0.226-0.398,0.226-0.692c0-0.366-0.082-0.628-0.248-0.785c-0.164-0.157-0.404-0.236-0.719-0.236
h-0.615c-0.338,0-0.59,0.075-0.758,0.226c-0.169,0.15-0.254,0.396-0.254,0.741s0.079,0.597,0.236,0.759
c0.158,0.16,0.391,0.241,0.698,0.241h0.638C157.74,15.667,158.006,15.582,158.155,15.414z"
      />
      <path
        :fill="fillColor"
        d="M162.012,18.353c-0.37-0.18-0.638-0.484-0.803-0.912c-0.164-0.429-0.246-1.035-0.246-1.818
c0-0.799,0.078-1.414,0.235-1.846c0.157-0.433,0.417-0.736,0.78-0.912c0.362-0.176,0.873-0.264,1.533-0.264
c0.578,0,1.035,0.059,1.373,0.176c0.336,0.117,0.582,0.32,0.736,0.609c0.153,0.289,0.23,0.694,0.23,1.215
c0,0.541-0.156,0.93-0.467,1.164c-0.312,0.234-0.764,0.352-1.357,0.352h-1.725c0.015,0.381,0.066,0.676,0.154,0.885
s0.242,0.361,0.467,0.455c0.223,0.096,0.547,0.144,0.972,0.144h1.78v0.802c-0.396,0.074-0.749,0.129-1.061,0.165
c-0.311,0.036-0.668,0.056-1.071,0.056C162.893,18.623,162.381,18.533,162.012,18.353z M163.896,15.292
c0.264,0,0.454-0.051,0.571-0.153s0.176-0.282,0.176-0.538c0-0.381-0.084-0.645-0.252-0.791c-0.169-0.146-0.462-0.221-0.879-0.221
c-0.315,0-0.559,0.05-0.73,0.148c-0.173,0.1-0.297,0.27-0.374,0.512c-0.077,0.241-0.116,0.59-0.116,1.043H163.896z"
      />
      <path
        :fill="fillColor"
        d="M167.17,12.677h1.055l0.308,0.945c0.257-0.322,0.528-0.572,0.818-0.752s0.617-0.27,0.983-0.27
c0.176,0,0.341,0.021,0.494,0.066v1.384c-0.278-0.029-0.502-0.044-0.67-0.044c-0.344,0-0.641,0.057-0.891,0.17
c-0.248,0.113-0.494,0.295-0.735,0.544v3.846h-1.362V12.677z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'EventManagerLogotype',
  props: {
    fillColor: {
      type: String,
      default: 'white',
    },
  },
};
</script>
